/* =========================================================
   MADSPEED7 — COLLECTION LOAD MORE
   Replaces numbered collection pagination
   Includes dynamic product counter
   ========================================================= */

(function () {

  function initLoadMore() {

    const grid = document.querySelector(
      '#product-grid'
    );

    const pagination = document.querySelector(
      '#ProductGridContainer .pagination-wrapper'
    );

    if (!grid || !pagination) return;

    if (
  document.querySelector(
    '.ms7-collection-load-more'
  ) ||
  document.querySelector(
    '.ms7-collection-product-count'
  )
) {
  return;
}

    const nextLink = pagination.querySelector(
      'a[aria-label="Next page"]'
    );

    if (!nextLink) {
      pagination.style.display = 'none';
      return;
    }

    pagination.style.display = 'none';

    /* -------------------------------------------------------
       Current page
       ------------------------------------------------------- */

    let currentPage =
      parseInt(
        pagination.getAttribute('data-page'),
        10
      ) || 1;

    /* -------------------------------------------------------
       Product count
       ------------------------------------------------------- */

    const productCountElement =
  document.querySelector(
    '.product-count-vertical'
  );

let totalProducts = 0;

if (productCountElement) {

  const countText =
    productCountElement.textContent;

  const countMatch =
    countText.match(/([\d,]+)\s*products?/i);

  if (countMatch) {

    totalProducts =
      parseInt(
        countMatch[1].replace(/,/g, ''),
        10
      );

  }

}

    /* -------------------------------------------------------
       Create counter
       ------------------------------------------------------- */

    const counter =
      document.createElement('div');

    counter.className =
      'ms7-collection-product-count';

    counter.textContent =
  'Showing ' +
  grid.querySelectorAll(':scope > li.grid__item').length +
  ' of ' +
  totalProducts +
  ' total';

    /* -------------------------------------------------------
       Create Load More button
       ------------------------------------------------------- */

    const buttonWrapper =
      document.createElement('div');

    buttonWrapper.className =
      'ms7-collection-load-more';

    const button =
      document.createElement('button');

    button.type = 'button';

    button.className =
      'ms7-collection-load-more__button';

    button.textContent =
      'LOAD MORE';

    buttonWrapper.appendChild(button);

    /* -------------------------------------------------------
       Insert counter and button
       ------------------------------------------------------- */

    grid.parentNode.insertBefore(
      counter,
      pagination
    );

    grid.parentNode.insertBefore(
      buttonWrapper,
      pagination
    );

    /* -------------------------------------------------------
       Build next page URL
       ------------------------------------------------------- */

    function getNextPageUrl() {

      const url =
        new URL(
          nextLink.href,
          window.location.origin
        );

      url.searchParams.set(
        'page',
        currentPage + 1
      );

      return url.toString();
    }

    /* -------------------------------------------------------
       Update counter
       ------------------------------------------------------- */

    function updateCounter() {

      const loadedProducts =
        grid.querySelectorAll(
          ':scope > li.grid__item'
        ).length;

      counter.textContent =
  'Showing ' +
  loadedProducts +
  ' of ' +
  totalProducts +
  ' total';
    }

    /* -------------------------------------------------------
       Load next page
       ------------------------------------------------------- */

    button.addEventListener(
      'click',
      async function () {

        const nextPage =
          currentPage + 1;

        const nextUrl =
          getNextPageUrl();

        button.disabled = true;

        button.textContent =
          'LOADING...';

        try {

          const response =
            await fetch(nextUrl, {
              headers: {
                'X-Requested-With':
                  'XMLHttpRequest'
              }
            });

          if (!response.ok) {
            throw new Error(
              'Failed to load products'
            );
          }

          const html =
            await response.text();

          const parser =
            new DOMParser();

          const documentHTML =
            parser.parseFromString(
              html,
              'text/html'
            );

          const nextGrid =
            documentHTML.querySelector(
              '#product-grid'
            );

          if (!nextGrid) {
            throw new Error(
              'Product grid not found'
            );
          }

          /* -------------------------------------------------
             Get products from next page
             ------------------------------------------------- */

          const products =
            nextGrid.querySelectorAll(
              ':scope > li.grid__item'
            );

          if (!products.length) {
            throw new Error(
              'No products found on next page'
            );
          }

          products.forEach(function (product) {

            grid.appendChild(
              product
            );

          });

          /* -------------------------------------------------
             Update current page
             ------------------------------------------------- */

          currentPage =
            nextPage;

          /* -------------------------------------------------
             Update counter
             ------------------------------------------------- */

          updateCounter();

          /* -------------------------------------------------
             Check for another page
             ------------------------------------------------- */

          const nextPagination =
            documentHTML.querySelector(
              '#ProductGridContainer .pagination-wrapper'
            );

          const futureNextLink =
            nextPagination
              ? nextPagination.querySelector(
                  'a[aria-label="Next page"]'
                )
              : null;

          if (futureNextLink) {

            button.disabled = false;

            button.textContent =
              'LOAD MORE';

          } else {

            buttonWrapper.remove();

          }

        } catch (error) {

          console.error(
            'MADSPEED7 Load More:',
            error
          );

          button.disabled = false;

          button.textContent =
            'LOAD MORE';

        }

      }
    );

  }

  /* -----------------------------------------------------------
     Initialise
     ----------------------------------------------------------- */

  document.addEventListener(
    'DOMContentLoaded',
    initLoadMore
  );

  window.addEventListener(
    'load',
    initLoadMore
  );

  const observer =
    new MutationObserver(function () {

      initLoadMore();

    });

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();